export default __webpack_public_path__ + "static/Moderat-Bold-35236f4f55844ff79aa6a9962c8ac971.woff";